import React from "react";
import { Tooltip, Box, useTheme } from "@mui/material";

interface CellRateProps {
  children: string | number;
}

const CellRate = ({ children }: CellRateProps) => {
  const theme = useTheme();
  // Convert children to a number safely
  const rawValue =
    typeof children === "string" ? parseFloat(children) : children;
  const ratingValue = isNaN(rawValue) ? 0 : rawValue;
  // If it's <= 1, consider it as a fraction and multiply by 100
  const displayValue = ratingValue <= 1 ? ratingValue * 100 : ratingValue;

  // Round to two decimal places for display text
  const formattedValue = displayValue.toFixed(2);

  return (
    <Tooltip title={`Rate: ${ratingValue}`}>
      <Box
        sx={{
          width: "100%",
          backgroundColor: theme.palette.action.hover,
          borderRadius: "4px",
          overflow: "hidden",
          height: "20px",
          position: "relative"
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${formattedValue}%`,
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[400],
            transition: "width 0.5s ease"
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            textAlign: "center",
            top: "0",
            lineHeight: "20px",
            color: theme.palette.text.primary,
            fontWeight: "bold",
            fontSize: "0.9rem"
          }}
        >
          {formattedValue}%
        </Box>
      </Box>
    </Tooltip>
  );
};

export default CellRate;
